import React, { useRef, useEffect, useCallback, useState} from 'react';
import {useContainerCoords} from "components/hooks/useContainerCoords.js"
import {connect} from 'react-redux';

const HEIGHT = 120;
const MacroSlider = ({macro, number, styling}) => { 

    let ref = useRef();
    let innerRef = useRef();
    let [value, setValue] = useState(number);
    let [editing, setEditing] = useState(false);
    let {getXY} = useContainerCoords({containerRef: ref});

    useEffect(() => {
        window.addEventListener("mouseup", onMouseUp);
        window.addEventListener("touchend", onTouchEnd);
        window.addEventListener("mousemove", onMouseMove);

        return () => {
            window.removeEventListener("mouseup", onMouseUp);
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("touchend", onTouchEnd);
        };
    }, [setEditing, editing, setValue]);

    const getTouch = (e) => {
        let found=undefined;
        for (let i=0; i < e.touches.length; i++) {
            if (e.touches[i].target === ref.current ||
                e.touches[i].target === innerRef.current) {
                found = e.touches[i];
            }
        }
        return found;
    };

    const onTouchEnd = useCallback((e) => {
        let touch = e.target === ref.current ||
            e.target === innerRef.current;
        if (touch && editing) {
            setEditing(false);
        }
    }, [editing, setEditing]);

    useEffect(() => {
        setValue(number);
    }, [number, setValue]);

    const onMouseMove = useCallback(e => {
        if (editing) {
            let {y, number} = editing;
            let {pageY} = e;
            let distY = y - pageY;
            let ratio = distY / y;
            let _number = ratio*(macro.max - macro.min) + number;
            _number = Math.max(macro.min, Math.min(macro.max, _number));
            if (isNaN(_number)) {
                return;
            }

            if (_number !== macro.value) {
                macro.setValue(_number);
                setValue(_number);
            }
        }
    }, [setEditing, editing, setValue]);

    const onMouseUp = useCallback(e => {
        if (editing) {
            setEditing(false);
        }
    }, [setEditing, editing]);

    const onSliderMouseMove = useCallback((e) => {
        if (!editing) {
            return;
        }
        e.stopPropagation();
        let {x,y} = getXY(e);
        let val = (HEIGHT - y) / HEIGHT;

        macro.setValue(val);
        setValue(val);
        setEditing({number: val, y: e.pageY});
    }, [editing, setValue, setEditing]);

    const onSliderTouchMove = useCallback((e) => {
        if (!editing) {
            return;
        }
        e.stopPropagation();
        let found = getTouch(e);
        if (!found) {
            return;
        }
        let {x,y} = getXY(found);
        let val = (HEIGHT - y) / HEIGHT;

        val = Math.min(1, Math.max(0, val));
        macro.setValue(val);
        setValue(val);
        setEditing({number: val, y: e.pageY});
    }, [editing, setValue, setEditing]);


    if (!macro) {
        return '';
    }
    let style = {
        height: HEIGHT * (value - macro.min) / (macro.max - macro.min),
        backgroundColor: styling["secondary-color"]
    };

    return (
        <div
          style={{backgroundColor: styling["primary-color"]}}
          ref={ref}
          onMouseMove={onSliderMouseMove}
          onTouchMove={onSliderTouchMove}
          onTouchStart={(e) => {
              e.stopPropagation();
              console.log("on touch start outter");
              setEditing({number, y: e.pageY});
          }}
          onMouseDown={(e) => {
              e.stopPropagation();
              setEditing({number, y: e.pageY});
          }}
          className="macro-slider">
          <div
            ref={innerRef}
            onTouchMove={onSliderTouchMove}
            onTouchStart={(e) => {
                console.log("on touch start inner");
                e.stopPropagation();
                setEditing({number, y: e.pageY});
            }}
            style={style} className="slider-indicator">
          </div>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      number: props.macro ? props.macro.value : 0,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MacroSlider);
